import { AlertTriangle, FlaskConical } from 'lucide-react';
import { SANDBOX_MODE, SANDBOX_RETAILERS } from '../config/sandbox';

const BYPASS_AUTH = import.meta.env.VITE_BYPASS_AUTH === 'true';

// Global env-status banner. Three states:
//   sandbox ON              → sky-blue notice, names the test retailer
//   sandbox OFF + bypass ON → amber warning: writes will be rejected with 401
//   otherwise               → renders nothing (prod-correct config)
export default function EnvBanner() {
  if (SANDBOX_MODE) {
    return (
      <div className="border-b border-sky-300 bg-sky-50 px-4 py-2 text-sm text-sky-900 flex items-center gap-2">
        <FlaskConical size={16} className="text-sky-700 flex-shrink-0" />
        <span>
          <span className="font-bold">SANDBOX MODE</span> — DB writes are intercepted and shown in the Sandbox console (bottom-right). Test supermarkets:{' '}
          {SANDBOX_RETAILERS.map((name, i) => (
            <span key={name}>
              {i > 0 && ', '}
              <code className="font-mono">{name}</code>
            </span>
          ))}.
          <span className="ml-2 text-sky-700">
            (Auth bypass: <code className="font-mono">{BYPASS_AUTH ? 'ON' : 'OFF'}</code>)
          </span>
        </span>
      </div>
    );
  }

  if (BYPASS_AUTH) {
    return (
      <div className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-900 flex items-center gap-2">
        <AlertTriangle size={16} className="text-amber-700 flex-shrink-0" />
        <span>
          <span className="font-bold">AUTH BYPASS ON without sandbox</span> — writes will hit the real API and be rejected with 401. Set <code className="font-mono">VITE_BYPASS_AUTH=false</code> and log in, or <code className="font-mono">VITE_SANDBOX_MODE=true</code>.
        </span>
      </div>
    );
  }

  return null;
}
